// .u_main-header
class UMainHeader extends Uneet {
  constructor(domElement) {
    super(domElement)
    this.isMenuOpen = false
    this.__init()
  }

  __init() {
    this.toggleMenu(false)
    const menuBtn = this._e.querySelector('button.open-nav')
    menuBtn.onClick(() => {
      this.toggleMenu()
    })
  }

  toggleMenu(force) {
    this._toggleState('isMenuOpen', force)
  }
}
